export default __webpack_public_path__ + "static/media/wallet-payment.21545893.svg";